import React, { Component } from 'react';
import { connect } from 'react-redux';
import styles from './styles.scss';
import UserRow from './userRow';
import { userActions } from 'actions/api/users';

class ManageUsers extends Component {
  state = { languageOptions: [] };

  componentWillMount() {
    this.props.dispatch(userActions.search({}));
    this.generateLanguageOptions();
  }

  generateLanguageOptions = () => {
    let options = [];
    this.props.languages
      .sort((a, b) => a.title_english.localeCompare(b.title_english))
      .forEach(language => {
        options.push({
          label: language.title_english,
          value: language.id,
          icon: (
            <div
              style={{
                backgroundSize: 'contain',
                backgroundPosition: '50%',
                backgroundRepeat: 'no-repeat',
                width: 34,
                height: 26,
                verticalAlign: 'middle'
              }}
              className={`img-thumbnail flag flag-icon-background flag-icon-${
                language.alpha2
              }`}
            />
          )
        });
      });

    this.setState({ languageOptions: options });
  };

  render() {
    return (
      <div className={styles.wrapper}>
        <div className={styles.title}>
          <div>Manage Users</div>
        </div>
        <div className={styles.cardWrapper}>
          <div className={styles.cardHeader} />
          <div className={styles.tableWrapper}>
            <div className={styles.headerWrapper}>
              <table>
                <thead>
                  <tr>
                    <th>Name (verified)</th>
                    <th>Email</th>
                    <th>Type</th>
                    <th>Language</th>
                    <th>Activated?</th>
                    <th className={styles.tightCol} />
                  </tr>
                </thead>
              </table>
            </div>
            <div className={styles.bodyWrapper}>
              <table>
                <tbody>
                  {this.props.users
                    .sort((a, b) => a.name.localeCompare(b.name))
                    .map(user => {
                      return (
                        <UserRow
                          key={user.id}
                          user={user}
                          languageOptions={this.state.languageOptions}
                        />
                      );
                    })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(state => {
  return { languages: state.languages.list, users: state.users.list };
})(ManageUsers);



// WEBPACK FOOTER //
// ./src/components/dashboard/developerDashboard/manageUsers/index.js